import React from "react";
import { ReactComponent as NoFoundImg } from "../../../assets/illustrations/404-240x240.svg";
import ServicesLayout from "../../../layouts/Services.layout";

export const MaintenancePage: React.FC = () => {
  return (
    <ServicesLayout
      image={<NoFoundImg />}
      title="The site is currently down for maintenance"
    >
      <div className="text-base theme-text-secondary">
        We apologize for any inconveniences caused. We’ll fix it soon.
      </div>
    </ServicesLayout>
  );
};
